import { ENUM } from "~/plugins/constants/enum";
import { displayDate, getChatbotStatus } from "~/plugins/functions/display";

// For DTO Preset
export interface IModelGETPresetRequest {
  orderBy: string;
  orderType: string;
  count: boolean;
  page: number;
  limit: number;
}

export interface IModelGETPresetResponse {
  id: string;
  name: string;
  description: any;
  modelName: string;
  tools: string[];
  knowledgeBase: string[];
  commandDetail: any;
  beginningMessage: any;
  toolSearchWeb: boolean;
  toolCanvas: boolean;
  toolDallEImage: boolean;
  toolCode: boolean;
  toolCodeText: any;
  createdAt: string | Date;
  createdBy: any;
  updatedAt: string | Date;
  updatedBy: any;
  softDeleted: boolean;
  status: string;
}

export class ModelGETPreset {
  id: string;
  name: string;
  description: any;
  modelName: string;
  toolsList: string[];
  knowledgeBaseList: string[];
  commandDetail: any;
  beginningMessage: any;
  toolSearchWeb: boolean;
  toolCanvas: boolean;
  toolDallEImage: boolean;
  toolCode: boolean;
  toolCodeText: any;
  createdAt: string | Date;
  createdBy: any;
  updatedAt: string | Date;
  updatedBy: any;
  softDeleted: boolean;
  status: string;

  displayCreatedAt: string;
  displayUpdatedAt: string;
  displayStatus: string;

  constructor(props = {} as IModelGETPresetResponse) {
    props = props ?? {} as IModelGETPresetResponse;
    this.id = props.id || '';
    this.name = props.name || '';
    this.description = props.description || null;
    this.modelName = props.modelName || '';
    this.toolsList = props.tools || [];
    this.knowledgeBaseList = props.knowledgeBase || [];
    this.commandDetail = props.commandDetail || null;
    this.beginningMessage = props.beginningMessage || null;
    this.toolSearchWeb = props.toolSearchWeb || false;
    this.toolCanvas = props.toolCanvas || false;
    this.toolDallEImage = props.toolDallEImage || false;
    this.toolCode = props.toolCode || false;
    this.toolCodeText = props.toolCodeText || null;
    this.createdAt = props.createdAt || '';
    this.createdBy = props.createdBy || null;
    this.updatedAt = props.updatedAt || '';
    this.updatedBy = props.updatedBy || null;
    this.softDeleted = props.softDeleted || false;
    this.status = props.status || '';

    this.displayCreatedAt = displayDate(this.createdAt, {
      isTime: true
    });
    this.displayUpdatedAt = displayDate(this.updatedAt, {
      isTime: true
    });
    this.displayStatus = getChatbotStatus(this.status)
  }
}